import { render, staticRenderFns } from "./customHeader.vue?vue&type=template&id=5a0e74ec&scoped=true&"
import script from "./customHeader.vue?vue&type=script&lang=js&"
export * from "./customHeader.vue?vue&type=script&lang=js&"
import style0 from "./customHeader.vue?vue&type=style&index=0&id=5a0e74ec&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a0e74ec",
  null
  
)

export default component.exports